import { useState, useRef, useEffect } from 'react';

function BookingItemWeek({ booking }) {
  // console.log(`TCL -> BookingItemWeek.jsx:4 -> BookingItemWeek -> booking:`, booking)
  
  const bookingRef = useRef(null);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (isHovered && bookingRef.current) {
      const rect = bookingRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.bottom + 8,
        left: rect.left + rect.width / 2
      });
    }
  }, [isHovered]);

  const startTime = booking.start ? booking.start.split('T')[1].substring(0, 5) : '';
  const endTime = booking.end ? booking.end.split('T')[1].substring(0, 5) : '';

  return (
    <>
      <div 
        ref={bookingRef}
        className="bg-blue-100 px-2 py-2 text-center w-full cursor-pointer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="font-bold text-gray-900 text-sm">{booking.title || booking.customerName}</div>
        <div className="text-gray-600 text-xs">{startTime}-{endTime}</div>
      </div>
      
      {/* Hover Tooltip */}
      {isHovered && (
        <div 
          className="fixed z-50 w-64 -translate-x-1/2" 
          style={{ 
            top: `${tooltipPosition.top}px`,
            left: `${tooltipPosition.left}px`
          }}
        >
          <div className="bg-gray-900 text-white text-sm rounded-lg shadow-lg p-4">
            <div className="absolute left-1/2 -translate-x-1/2 bottom-full w-0 h-0 border-l-8 border-r-8 border-b-8 border-transparent border-b-gray-900"></div>
            {booking.title && (
              <div className="mb-2">
                <div className="font-bold mb-1">Booking Title</div>
                <div>{booking.title}</div>
              </div>
            )}
            <div className="mb-2">
              <div className="font-bold mb-1">Resource</div>
              <div>{booking.resourceName}</div>
            </div>
            <div className="mb-2">
              <div className="font-bold mb-1">Customer</div>
              <div>{booking.customerName}</div>
            </div>
            <div className="mb-2">
              <div className="font-bold mb-1">Telephone</div>
              <div>{booking.customerTel}</div>
            </div>
            <div className="mb-2">
              <div className="font-bold mb-1">Timing</div>
              <div>{booking.start.split('T')[0]} {startTime} - {endTime}</div>
            </div>

            <div>
              <div className="font-bold mb-1">Notes</div>
              <div className="text-gray-300">{booking.notes}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BookingItemWeek;
